var render = function render(){var _vm=this,_c=_vm._self._c;return _c('payments-table',{attrs:{"payments":_vm.payments,"simplify":"","title-bar":""}},[_c('create-payment')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }